export const HurryIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M16 8.71C16 12.03 13.27 14.76 9.95 14.76C9.56 14.76 9.07 14.66 8.68 14.66C8.97 14.46 9.07 14.07 9.17 13.78C9.46 13.78 9.66 13.88 9.95 13.88C12.78 13.88 15.02 11.64 15.02 8.81C15.02 5.98 12.78 3.74 9.95 3.74C8.39 3.74 7.02 4.42 6.05 5.59C6.05 5.59 6.05 5.69 5.95 5.69C5.56 6.18 5.27 6.86 5.07 7.54H4.09C4.29 6.76 4.58 6.08 5.07 5.39L4.09 4.41C3.89 4.21 3.89 3.92 4.09 3.73C4.29 3.54 4.58 3.53 4.77 3.73L5.65 4.61C6.63 3.54 7.99 2.95 9.45 2.76V1.98H8.28C7.99 1.98 7.79 1.78 7.79 1.49C7.79 1.2 7.99 1 8.28 1H11.69C11.98 1 12.18 1.2 12.18 1.49C12.18 1.78 11.89 1.98 11.69 1.98H10.52V2.76C13.54 2.96 15.98 5.59 15.98 8.71H16Z"
                fill="#CA9396"
            />
            <path
                d="M9.75988 9.48966C9.65988 9.48966 9.46988 9.38966 9.36988 9.28966C9.26988 9.08966 9.26988 8.79966 9.46988 8.60966L12.2999 6.16966C12.4999 5.96966 12.7899 5.96966 12.9799 6.26966C13.1799 6.46966 13.1799 6.75966 12.8799 6.94966L10.0499 9.38966C10.0499 9.38966 9.84988 9.38966 9.75988 9.48966Z"
                fill="#CA9396"
            />
            <path
                d="M8.2 9.00001C8.2 9.29001 8 9.49001 7.71 9.49001H0.49C0.2 9.49001 0 9.20001 0 9.00001C0 8.80001 0.2 8.51001 0.49 8.51001H7.71C8 8.51001 8.2 8.71001 8.2 9.00001Z"
                fill="#CA9396"
            />
            <path
                d="M7.71 11.73H2.93C2.64 11.73 2.44 11.53 2.44 11.24C2.44 10.95 2.64 10.75 2.93 10.75H7.71C8 10.75 8.2 10.95 8.2 11.24C8.2 11.53 8 11.73 7.71 11.73Z"
                fill="#CA9396"
            />
            <path
                d="M8.19988 13.5896C8.19988 13.8796 7.99988 14.0796 7.70988 14.0796H5.36988C5.07988 14.0796 4.87988 13.8796 4.87988 13.5896C4.87988 13.2996 5.07988 13.0996 5.36988 13.0996H7.70988C7.99988 13.0996 8.19988 13.2996 8.19988 13.5896C8.19988 13.5229 8.19988 13.5229 8.19988 13.5896Z"
                fill="#CA9396"
            />
        </svg>
    );
};
